import React from "react";
import VisaHeader from "./VisaHeader";
import TitleCard from "./titlecard";
import VisaPrice from "./VisaPrice";
import VisaRateCalculator from "./VisaRate";
import FAQ from "./FAQ";
import StatsPanel from "./StatsPanel";
import "./VisaMain.css";

const VisaMain = () => {
  return (
    <div className='visamain' >
      
      <VisaHeader/>

      <div className='visamainsub' >
        <TitleCard />
        <VisaPrice />
        <VisaRateCalculator />
        <FAQ />
        <StatsPanel />
      </div>
      
    </div>
  );
};

export default VisaMain;
